const initialState = {
	expires_at: null,
	refresh_token: null,
	token: null,
	user: {},
	oneSignalId: null,
	oneSignalDone: false,
	oneSignalPreference: false,
}

export default function reduce(state = initialState, action) {
	switch (action.type) {
		case 'LOGOUT':
			return initialState

		case 'SET_LIGHTSPEED_STATE':
			return {
				...state,
				lightspeedState: action.payload,
				connection_id: action.connection_id,
			}

		case 'USERS': {
			const user = action.users.find(u => u.id == state.user.id)
			return {
				...state,
				user: {...state.user, ...user},
			}
		}
		case 'SET_TOKENS':
			return {
				...state,
				token: action.token,
				refresh_token: action.refresh_token,
				expires_at: action.expires_at,
				...(action.envId ? {envId: action.envId} : {}),
				...(action.envName ? {envName: action.envName} : {}),
			}

		case 'AUTH_SUCCESS': {
			const user = action.user ? {...action.user, avatar: action.user.image} : null
			return {
				...state,
				...action,
				user,
			}
		}

		case 'LOGOUT_FLOOR_USER': {
			return {
				...state,
				user: null,
				user_token: null,
			}
		}

		case 'UPDATE_USER':
			return {
				...state,
				user: {...state.user, ...action.payload.user},
			}

		case 'ONE_SIGNAL_ID':
			return {
				...state,
				oneSignalId: action.id,
			}
		case 'ONE_SIGNAL_DONE':
			return {
				...state,
				oneSignalDone: true,
			}

		case 'UPDATE_USER_SETTING': {
			const newState = {
				...state,
				user: {...state.user, ...action.settings},
			}
			return newState
		}

		default:
			return state
	}
}
